import React from 'react'

const Snp8 = () => {
    return (
        <div>
            <div className='container'>
            <h1>Find minimum number of coins that make a given value</h1>
            <p>Given a value V, if we want to make change for V cents, and we have infinite supply of each of C = &#123; C1, C2, .. , Cm&#125; valued coins, what is the minimum number of coins to make the change? If it’s not possible to make change, print -1.</p>
            <p><strong>Examples:</strong>&nbsp;&nbsp;</p>
            <pre className='containers'>Input: coins[] = &#123;25, 10, 5&#125;, V = 30 <br />
Output: Minimum 2 coins required <br />
We can use one coin of 25 cents and one of 5 cents  <br />
 <br />
Input: coins[] = &#123;9, 6, 5, 1&#125;, V = 11 <br />
Output: Minimum 2 coins required <br />
We can use one coin of 6 cents and 1 coin of 5 cents</pre> <br />
<p>The minimum number of coins for a value V can be computed using below recursive formula.&nbsp;</p>
<pre className='containers'>If V == 0, then 0 coins required. <br />
If V &gt; 0 <br />
   minCoins(coins[0..m-1], V) = min &#123;1 + minCoins(V-coin[i])&#125; <br /> 
                               where i varies from 0 to m-1  <br />
                               and coin[i] &lt;= V</pre>

            <div className='tabs'>
    <input type="radio" name="tab" id="tab1" />
    <label for="tab1">CPP</label>
    <input type="radio" name="tab" id="tab2"/>
    <label for="tab2">Java </label>
    <input type="radio" name="tab" id="tab3"/>
    <label for="tab3">Python</label>


  
    <div class="tab-content-wrapper">
      <div id="tab-content-1" class="tab-content">
      <div class="container">
    <div class="line number1 index0 alt2"><code
            class="comments">// A Naive recursive C++ program to find minimum of coins</code></div>
    <div class="line number2 index1 alt1"><code class="comments">// to make a given change V</code></div>
    <div class="line number3 index2 alt2"><code class="preprocessor">#include&lt;bits/stdc++.h&gt;</code></div>
    <div class="line number4 index3 alt1"><code class="keyword bold">using</code> <code
            class="keyword bold">namespace</code> <code class="plain">std;</code></div>
    <div class="line number5 index4 alt2">&nbsp;</div>
    <div class="line number6 index5 alt1"><code
            class="comments">// m is size of coins array (number of different coins)</code></div>
    <div class="line number7 index6 alt2"><code class="color1 bold">int</code> <code class="plain">minCoins(</code><code
            class="color1 bold">int</code> <code class="plain">coins[], </code><code class="color1 bold">int</code>
        <code class="plain">m, </code><code class="color1 bold">int</code> <code class="plain">V)</code></div>
    <div class="line number8 index7 alt1"><code class="plain">&#123;</code></div>
    <div class="line number9 index8 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;</code><code
            class="comments">// base case</code></div>
    <div class="line number10 index9 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;</code><code
            class="keyword bold">if</code> <code class="plain">(V == 0) </code><code class="keyword bold">return</code>
        <code class="plain">0;</code></div>
    <div class="line number11 index10 alt2">&nbsp;</div>
    <div class="line number12 index11 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;</code><code
            class="comments">// Initialize result</code></div>
    <div class="line number13 index12 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;</code><code
            class="color1 bold">int</code> <code class="plain">res = INT_MAX;</code></div>
    <div class="line number14 index13 alt1">&nbsp;</div>
    <div class="line number15 index14 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;</code><code
            class="comments">// Try every coin that has smaller value than V</code></div>
    <div class="line number16 index15 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;</code><code
            class="keyword bold">for</code> <code class="plain">(</code><code class="color1 bold">int</code> <code
            class="plain">i=0; i&lt;m; i++)</code></div>
    <div class="line number17 index16 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;</code><code
            class="plain">&#123;</code></div>
    <div class="line number18 index17 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword bold">if</code> <code class="plain">(coins[i] &lt;= V)</code></div>
    <div class="line number19 index18 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">&#123;</code></div>
    <div class="line number20 index19 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="color1 bold">int</code> <code class="plain">sub_res = minCoins(coins, m, V-coins[i]);</code></div>
    <div class="line number21 index20 alt2">&nbsp;</div>
    <div class="line number22 index21 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">// Check for INT_MAX to avoid overflow and see if</code></div>
    <div class="line number23 index22 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">// result can minimized</code></div>
    <div class="line number24 index23 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword bold">if</code> <code
            class="plain">(sub_res != INT_MAX &amp;&amp; sub_res + 1 &lt; res)</code></div>
    <div class="line number25 index24 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">res = sub_res + 1;</code></div>
    <div class="line number26 index25 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">&#125;</code></div>
    <div class="line number27 index26 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;</code><code
            class="plain">&#125;</code></div>
    <div class="line number28 index27 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;</code><code
            class="keyword bold">return</code> <code class="plain">res;</code></div>
    <div class="line number29 index28 alt2"><code class="plain">&#125;</code></div>
    <div class="line number30 index29 alt1">&nbsp;</div>
    <div class="line number31 index30 alt2"><code class="comments">// Driver program to test above function</code></div>
    <div class="line number32 index31 alt1"><code class="color1 bold">int</code> <code class="plain">main()</code></div>
    <div class="line number33 index32 alt2"><code class="plain">&#123;</code></div>
    <div class="line number34 index33 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="color1 bold">int</code> <code class="plain">coins[] =&nbsp; &#123;9, 6, 5, 1&#125;;</code></div>
    <div class="line number35 index34 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="color1 bold">int</code> <code class="plain">m = </code><code class="keyword bold">sizeof</code><code
            class="plain">(coins)/</code><code class="keyword bold">sizeof</code><code class="plain">(coins[0]);</code>
    </div>
    <div class="line number36 index35 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="color1 bold">int</code> <code class="plain">V = 11;</code></div>
    <div class="line number37 index36 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">cout &lt;&lt; </code><code class="string">"Minimum coins required is "</code></div>
    <div class="line number38 index37 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">&lt;&lt; minCoins(coins, m, V);</code></div>
    <div class="line number39 index38 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword bold">return</code> <code class="plain">0;</code></div>
    <div class="line number40 index39 alt1"><code class="plain">&#125;</code></div>
</div>
     </div>
      <div id="tab-content-2" class="tab-content">
      <div class="container">
    <div class="line number1 index0 alt2"><code
            class="comments">// A Naive recursive JAVA program to find minimum of coins</code></div>
    <div class="line number2 index1 alt1"><code class="comments">// to make a given change V</code></div>
    <div class="line number3 index2 alt2"><code class="keyword">class</code> <code class="plain">coin</code></div>
    <div class="line number4 index3 alt1"><code class="plain">&#123;</code></div>
    <div class="line number5 index4 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">// m is size of coins array (number of different coins)</code></div>
    <div class="line number6 index5 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">static</code> <code class="keyword">int</code> <code class="plain">minCoins(</code><code
            class="keyword">int</code> <code class="plain">coins[], </code><code class="keyword">int</code> <code
            class="plain">m, </code><code class="keyword">int</code> <code class="plain">V)</code></div>
    <div class="line number7 index6 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">&#123;</code></div>
    <div class="line number8 index7 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">// base case</code></div>
    <div class="line number9 index8 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="keyword">if</code>
        <code class="plain">(V == </code><code class="value">0</code><code class="plain">) </code><code
            class="keyword">return</code> <code class="value">0</code><code class="plain">;</code></div>
    <div class="line number10 index9 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code>&nbsp;
    </div>
    <div class="line number11 index10 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">// Initialize result</code></div>
    <div class="line number12 index11 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="keyword">int</code>
        <code class="plain">res = Integer.MAX_VALUE;</code></div>
    <div class="line number13 index12 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code>&nbsp;
    </div>
    <div class="line number14 index13 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">// Try every coin that has smaller value than V</code></div>
    <div class="line number15 index14 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="keyword">for</code>
        <code class="plain">(</code><code class="keyword">int</code> <code class="plain">i=</code><code
            class="value">0</code><code class="plain">; i&lt;m; i++)</code></div>
    <div class="line number16 index15 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="plain">&#123;</code></div>
    <div class="line number17 index16 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">if</code> <code class="plain">(coins[i] &lt;= V)</code></div>
    <div class="line number18 index17 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">&#123;</code></div>
    <div class="line number19 index18 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">int</code> <code class="plain">sub_res = minCoins(coins, m, V-coins[i]);</code></div>
    <div class="line number20 index19 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code>&nbsp;
    </div>
    <div class="line number21 index20 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">// Check for INT_MAX to avoid overflow and see if</code></div>
    <div class="line number22 index21 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">// result can minimized</code></div>
    <div class="line number23 index22 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">if</code> <code
            class="plain">(sub_res != Integer.MAX_VALUE &amp;&amp; sub_res + </code><code class="value">1</code> <code
            class="plain">&lt; res)</code></div>
    <div class="line number24 index23 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">res = sub_res + </code><code class="value">1</code><code class="plain">;</code></div>
    <div class="line number25 index24 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">&#125;</code></div>
    <div class="line number26 index25 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="plain">&#125;</code></div>
    <div class="line number27 index26 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">return</code> <code class="plain">res;</code></div>
    <div class="line number28 index27 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">&#125;</code></div>
    <div class="line number29 index28 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">public</code> <code class="keyword">static</code> <code class="keyword">void</code> <code
            class="plain">main(String args[])</code></div>
    <div class="line number30 index29 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">&#123;</code></div>
    <div class="line number31 index30 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="keyword">int</code>
        <code class="plain">coins[] =&nbsp; &#123;</code><code class="value">9</code><code class="plain">, </code><code
            class="value">6</code><code class="plain">, </code><code class="value">5</code><code
            class="plain">, </code><code class="value">1</code><code class="plain">&#125;;</code></div>
    <div class="line number32 index31 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="keyword">int</code>
        <code class="plain">m = coins.length;</code></div>
    <div class="line number33 index32 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="keyword">int</code>
        <code class="plain">V = </code><code class="value">11</code><code class="plain">;</code></div>
    <div class="line number34 index33 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">System.out.println(</code><code class="string">"Minimum coins required is "</code><code
            class="plain">+ minCoins(coins, m, V) );</code></div>
    <div class="line number35 index34 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">&#125;</code></div>
    <div class="line number36 index35 alt1"><code class="plain">&#125;</code><code
            class="comments">/* This code is contributed by Rajat Mishra */</code></div>
</div>
      </div>
      <div id="tab-content-3" class="tab-content">
      <div class="container">
    <div class="line number1 index0 alt2"><code
            class="comments"># A Naive recursive python program to find minimum of coins</code></div>
    <div class="line number2 index1 alt1"><code class="comments"># to make a given change V</code></div>
    <div class="line number3 index2 alt2">&nbsp;</div>
    <div class="line number4 index3 alt1"><code class="keyword">import</code> <code class="plain">sys</code></div>
    <div class="line number5 index4 alt2">&nbsp;</div>
    <div class="line number6 index5 alt1"><code
            class="comments"># m is size of coins array (number of different coins)</code></div>
    <div class="line number7 index6 alt2"><code class="keyword">def</code> <code
            class="plain">minCoins(coins, m, V):</code></div>
    <div class="line number8 index7 alt1">&nbsp;</div>
    <div class="line number9 index8 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments"># base case</code></div>
    <div class="line number10 index9 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">if</code> <code class="plain">(V </code><code class="keyword">=</code><code
            class="keyword">=</code> <code class="value">0</code><code class="plain">):</code></div>
    <div class="line number11 index10 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">return</code> <code class="value">0</code></div>
    <div class="line number12 index11 alt1">&nbsp;</div>
    <div class="line number13 index12 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments"># Initialize result</code></div>
    <div class="line number14 index13 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">res </code><code class="keyword">=</code> <code class="plain">sys.maxsize</code></div>
    <div class="line number15 index14 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code>&nbsp;</div>
    <div class="line number16 index15 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments"># Try every coin that has smaller value than V</code></div>
    <div class="line number17 index16 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">for</code> <code class="plain">i </code><code class="keyword">in</code> <code
            class="functions">range</code><code class="plain">(</code><code class="value">0</code><code
            class="plain">, m):</code></div>
    <div class="line number18 index17 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">if</code> <code class="plain">(coins[i] &lt;</code><code class="keyword">=</code> <code
            class="plain">V):</code></div>
    <div class="line number19 index18 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">sub_res </code><code class="keyword">=</code> <code
            class="plain">minCoins(coins, m, V</code><code class="keyword">-</code><code class="plain">coins[i])</code>
    </div>
    <div class="line number20 index19 alt1">&nbsp;</div>
    <div class="line number21 index20 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments"># Check for INT_MAX to avoid overflow and see if</code></div>
    <div class="line number22 index21 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments"># result can minimized</code></div>
    <div class="line number23 index22 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">if</code> <code class="plain">(sub_res !</code><code class="keyword">=</code> <code
            class="plain">sys.maxsize </code><code class="keyword">and</code> <code class="plain">sub_res </code><code
            class="keyword">+</code> <code class="value">1</code> <code class="plain">&lt; res):</code></div>
    <div class="line number24 index23 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">res </code><code class="keyword">=</code> <code class="plain">sub_res </code><code
            class="keyword">+</code> <code class="value">1</code></div>
    <div class="line number25 index24 alt2">&nbsp;</div>
    <div class="line number26 index25 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">return</code> <code class="plain">res</code></div>
    <div class="line number27 index26 alt2">&nbsp;</div>
    <div class="line number28 index27 alt1"><code class="comments"># Driver program to test above function</code></div>
    <div class="line number29 index28 alt2"><code class="plain">coins </code><code class="keyword">=</code> <code
            class="plain">[</code><code class="value">9</code><code class="plain">, </code><code
            class="value">6</code><code class="plain">, </code><code class="value">5</code><code
            class="plain">, </code><code class="value">1</code><code class="plain">]</code></div>
    <div class="line number30 index29 alt1"><code class="plain">m </code><code class="keyword">=</code> <code
            class="functions">len</code><code class="plain">(coins)</code></div>
    <div class="line number31 index30 alt2"><code class="plain">V </code><code class="keyword">=</code> <code
            class="value">11</code></div>
    <div class="line number32 index31 alt1"><code class="functions">print</code><code class="plain">(</code><code
            class="string">"Minimum coins required is"</code><code class="plain">,minCoins(coins, m, V))</code></div>
    <div class="line number33 index32 alt2">&nbsp;</div>
    <div class="line number34 index33 alt1"><code class="comments"># This code is contributed by</code></div>
    <div class="line number35 index34 alt2"><code class="comments"># Smitha Dinesh Semwal</code></div>
</div>
  </div>

     </div>
  </div>
  <br /> <br /> <br /> <br /> <br />
        </div>
        </div>
    )
}

export default Snp8
